import { render, staticRenderFns } from "./ecAdresse.vue?vue&type=template&id=2b6449c8&lang=pug"
import script from "./ecAdresse.vue?vue&type=script&lang=js"
export * from "./ecAdresse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VAutocomplete: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VAutocomplete/VAutocomplete.js').default,VSelect: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VSelect/VSelect.js').default})
